import { useTranslator } from "@sunrise/translator";
import clsx from "clsx";
import { type ReactElement } from "react";

import { FocusButton, Header } from "@/components";
import { ICON_SIZE_20 } from "@/components/icon/icon.config";

import { FocusContainer } from "../../utils/focus-container";
import { ChannelGroupSelector } from "./channel-group-selector";
import * as styles from "./guide-controls.css";
import { useGridDateSelector } from "./hooks/use-grid-date-selector";

export function GuideControls({
  focusKey,
  onBack,
}: {
  focusKey: string;
  onBack: () => void;
}): ReactElement {
  const t = useTranslator();

  const { currentlySelectedDate, selectDate, moveToNow, moveToPrimeTime } =
    useGridDateSelector();

  // TODO: Refactor:
  // Move Header to routes/guid, and passed "grid-nav-now" button as a child.
  // The now button should encapsulate "moveToNow" callback
  return (
    <FocusContainer focusKey={focusKey} onLeft={onBack} onBack={onBack}>
      {(directions) => (
        <Header
          left={
            <>
              <FocusButton
                className={clsx([styles.button, styles.dayFilterButton])}
                text={currentlySelectedDate}
                focusKey="grid-nav-date"
                onArrowPress={directions.onArrowPress("left")}
                onEnterPress={selectDate} // open dialog to select new date
                iconRight="dropdown-down"
                iconSize={ICON_SIZE_20}
                textAlign="left"
              />
              <FocusButton
                className={styles.button}
                text={t("guide_now_button")}
                focusKey="grid-nav-now"
                onEnterPress={moveToNow}
              />
              <FocusButton
                className={styles.button}
                text={t("guide_primetime_button")}
                focusKey="grid-nav-prime-time"
                onEnterPress={moveToPrimeTime}
              />
            </>
          }
          right={<ChannelGroupSelector />}
        />
      )}
    </FocusContainer>
  );
}
